
import { defineComponent } from "vue";
import Referal from "@/components/Referal/Referal.vue";
import ReferalSuccess from "@/components/Referal/ReferalSuccess.vue";
import ReferalFromApps from "@/components/Referal/ReferalFromApps.vue";
import LinkLoader from "@/components/LinkLoader.vue";
import {
  ISubmitData,
  IReferalViewData,
  StoreEnum,
} from "@/components/Referal/types";
import axios from "axios";

export default defineComponent({
  name: "ReferalView",
  components: { Referal, ReferalSuccess, ReferalFromApps, LinkLoader },

  data(): IReferalViewData {
    return {
      userData: null,
      isSuccess: false,
      isLoading: false,
      showError: false,
      buttonLinks: [
        {
          url: process.env.VUE_APP_REFERAL_PLAY_MARKET,
          type: StoreEnum.googleStore,
          logo: "./assets/img/google-play-icon.svg",
        },
        {
          url: process.env.VUE_APP_REFERAL_APP_STORE,
          type: StoreEnum.appStore,
          logo: "./assets/img/app-store-icon.svg",
        },
        {
          url: process.env.VUE_APP_REFERAL_RU_STORE,
          type: StoreEnum.ruStore,
          logo: "./assets/img/ru-store-icon.svg",
        },
        {
          url: process.env.VUE_APP_REFERAL_WEBSITE,
          type: StoreEnum.website,
          logo: "./assets/img/website.svg",
        },
      ],
    };
  },

  computed: {
    referalOnlyFromApp() {
      if (typeof process.env.VUE_APP_IS_REFERAL_FROM_APPS === "boolean") {
        return process.env.VUE_APP_IS_REFERAL_FROM_APPS;
      }
      if (typeof process.env.VUE_APP_IS_REFERAL_FROM_APPS === "string") {
        return process.env.VUE_APP_IS_REFERAL_FROM_APPS === "TRUE";
      }
      return false;
    },
  },

  methods: {
    async submitData(e: ISubmitData) {
      try {
        this.isLoading = true;
        this.showError = false;
        await axios.post(process.env.VUE_APP_FURCA_URL + "/api/referal", {
          ...e.query,
          userPhone: e.phoneNumber,
        });

        this.isSuccess = true;
        this.isLoading = false;
        this.userData = {
          phoneNumber: e.phoneNumber,
          stringNumber: e.stringNumber,
          isAgree: e.isAgree,
        };
      } catch (e) {
        this.isLoading = false;
        this.isSuccess = false;
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 3000);
        console.log("error-referalView: ", e);
      }
    },
  },
});
